/* eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents */
export function label(code: string, displayName?: string | null | unknown): string {
  if (typeof displayName === "string" && displayName.trim().length > 0) {
    return displayName.trim();
  }
  return code;
}

